import { ValidationIssue } from 'api'
import { Locale, Translation } from 'locale'
import { getDateEditorFormat } from 'model'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { userPreferenceSelector } from 'selectors/userPreferenceSelectors'
import { DatePickerField } from 'view/components/inputs'
import { DateRange, DateRangeSelectboxField } from 'view/shared/entity/DateRangeSelectbox'
import { createInvalidDateRangeValuesValidationIssues } from '../utils'

interface SubscriptionDateRangeComponentProps {
  label: Translation
  onUpdate: (subscriptionDates: SubscriptionDates, validationIssues: ValidationIssue[]) => void
  minDate?: Date | undefined
  filterDate?: (value: Date) => boolean
  initialSubscriptionDates: SubscriptionDates
}

export type SubscriptionDates = {
  firstDate: string | null
  secondDate: string | null
  dateRange: DateRange
}

export const SubscriptionDateRangeComponent: React.FC<SubscriptionDateRangeComponentProps> = props => {
  const { label, onUpdate, minDate, filterDate, initialSubscriptionDates } = props
  const userPreference = useSelector(userPreferenceSelector)

  const [subscriptionDates, setSubscriptionDates] = useState<SubscriptionDates>(initialSubscriptionDates)
  const [validationIssues, setValidationIssues] = useState<ValidationIssue[]>()

  const handleSubscriptionDatesUpdate = (key: keyof SubscriptionDates) => (value: string | DateRange | null) => {
    const updatedSubscriptionDates = { ...subscriptionDates, [key]: value }
    const validationIssues: ValidationIssue[] = createInvalidDateRangeValuesValidationIssues(updatedSubscriptionDates, 'secondDate')

    setValidationIssues(validationIssues)
    setSubscriptionDates(updatedSubscriptionDates)
    onUpdate(updatedSubscriptionDates, validationIssues)
  }

  const firstDate = subscriptionDates.firstDate ? subscriptionDates.firstDate : null
  const secondDate = subscriptionDates.secondDate ? subscriptionDates.secondDate : null

  return (
    <>
      <label>{Locale.translate(label)}</label>
      <DateRangeSelectboxField label={''} value={subscriptionDates.dateRange} onUpdate={handleSubscriptionDatesUpdate('dateRange')} />
      <DatePickerField
        label={''}
        value={firstDate}
        onUpdate={handleSubscriptionDatesUpdate('firstDate')}
        minDate={minDate}
        filterDate={filterDate}
        dateFormat={getDateEditorFormat(userPreference.dateFormat)}
        dataTestId={'SubscriptionDateRange-FirstDate-DatePicker'}
      />
      {subscriptionDates.dateRange === DateRange.Between ? (
        <DatePickerField
          label={''}
          value={secondDate}
          onUpdate={handleSubscriptionDatesUpdate('secondDate')}
          minDate={minDate}
          filterDate={filterDate}
          dateFormat={getDateEditorFormat(userPreference.dateFormat)}
          fieldName={'secondDate'}
          validationIssues={validationIssues}
        />
      ) : null}
    </>
  )
}
